import { isAxiosError } from "axios";

// Deaktif hesap bilgisi login ekranına sessionStorage'la taşınır (URL'e email koymamak için).
// Değer: kullanıcının emaili (bilinmiyorsa boş string); anahtar yoksa hesap deaktif değil.
export const DEACTIVATED_KEY = "kaizu_deactivated";

export function isDeactivatedError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const message = (error.response?.data as { message?: string } | undefined)?.message || "";
  // login 403 "Hesap deaktif", guard 401 "Hesap deaktif", refresh 401 "Hesap bulunamadi veya deaktif"
  return /deaktif/i.test(message);
}

export function getDeactivatedEmail(): string | null {
  try {
    return sessionStorage.getItem(DEACTIVATED_KEY);
  } catch {
    return null;
  }
}

export function setDeactivatedEmail(email: string | null) {
  try {
    if (email === null) sessionStorage.removeItem(DEACTIVATED_KEY);
    else sessionStorage.setItem(DEACTIVATED_KEY, email);
  } catch {
    // sessionStorage yoksa bildirim sadece bu render'da görünür
  }
}
